
<div class="ws-select ws-field wrapper">
  <slot
    name="custom-display"
    :selected-value="displayValue"
    :open-dropdown="openDropdown"
    :raw-selected-value="selectedValue"
  ></slot>
  <q-select
    ref="qfield"
    v-bind="$attrs"
    :name="name"
    :emit-value="emitValue"
    :value="selectedValue"
    :options="filteredOptions"
    class="ws-select-inner"
    :display-value="displayValue"
    :class="{
      'ws-select-chips': $attrs['use-chips'] === '',
      'ws-select-empty': value === '' || get(value, 'length') === 0,
      'ws-dark': dark,
      'q-field--error': errorDesign,
      'messages-overflow': messagesOverflow,
      'custom-display': isCustomDisplay
    }"
    :popup-content-class="
      ($attrs['popup-content-class'] || '') + ' ws-select-content wsk-root wsk-app wsk-portal ws-typography'
        + (widePaddings ? ' wide-paddings' : '')
        + (optionsWithList ? ' options-with-list' : '')
    "
    :bg-color="bgColor || (dark ? 'dark' : 'white')"
    :standout="dark ? 'bg-dark text-white' : 'bg-white ws-text-darker'"
    :dark="dark"
    :placeholder="getPlaceholder"
    :square="isTheme(Theme.ADMIN)"
    :multiple="multiple"
    outlined
    :use-chips="multiple"
    no-error-icon
    :use-input="allowCustomValue || reduceOptionsByQuery || withInput || useInput"
    :fill-input="allowCustomValue && !multiple"
    :hide-selected="allowCustomValue && !multiple"
    :input-debounce="reduceOptionsByQuery ? 300 : undefined"
    lazy-rules
    transition-show="jump-down"
    transition-hide="jump-up"
    bottom-slots
    :error="!!messages.length"
    :error-message="inputErrorMessage"
    behavior="menu"
    hide-dropdown-icon
    @filter="filterOptions"
    v-on="$listeners"
    @new-value="createValue"
    @focus="onFocus"
    @focusout.native="onFocusOut"
    @input="onInput"
    @input-value="onInputValueChange"
    @keydown.enter="handleEnter"
  >
    <template v-if="icon" v-slot:append>
      <ws-icon :name="icon" style="height: 100%" />
    </template>

    <template v-if="optionsWithList" v-slot:selected-item="{opt}">
      <ws-select-option-with-list
        class="q-mb-sm"
        :border="false"
        :option="opt"
      ></ws-select-option-with-list>
    </template>

    <template v-if="multiple" v-slot:before-options>
      <div class="q-mx-md q-py-md" style="border-bottom: 1px solid #BEC8D1">
        <!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
        <!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
        <div class="q-item cursor-pointer flex flex-row no-margin" @click="selectAll">
          <ws-checkbox :value="allSelected" class="q-mr-md"></ws-checkbox>
          <span>{{ $t('uikit:ws_table.label.select_all') }}</span>
        </div>
        <!-- eslint-enable vuejs-accessibility/no-static-element-interactions -->
        <!-- eslint-enable vuejs-accessibility/click-events-have-key-events -->
      </div>
    </template>

    <!-- credit: https://stackoverflow.com/a/50892881/861615
      $slots and $scopedSlots cannot be merged because:
      https://stackoverflow.com/questions/64099203/#comment118694097_64099515
    -->

    <template v-slot:option="{ itemProps, opt, selected, toggleOption }">
      <q-item v-bind="itemProps" class="q-pa-5xl" @click.capture.stop="toggleOption(opt)">
        <template v-if="optionsWithList">
          <q-item-section>
            <ws-select-option-with-list
              :option="opt"
            ></ws-select-option-with-list>
          </q-item-section>
        </template>
        <template v-else>
          <q-item-section v-if="multiple" side class="q-mr-sm">
            <ws-checkbox :value="selected"></ws-checkbox>
          </q-item-section>
          <q-item-section v-if="opt.icon" side>
            <ws-icon :name="opt.icon" :height="16"></ws-icon>
          </q-item-section>
          <q-item-section>
            <q-item-label>{{ typeof opt === 'string' ? opt : opt.label }}</q-item-label>
          </q-item-section>
        </template>
      </q-item>
    </template>

    <template v-for="(_, slot) of slots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope"></slot>
    </template>

    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="{ ...scope, emphasiseQuery }"></slot>
    </template>
  </q-select>
</div>
